<div (click)="onVisibilityChange.emit()">
  <ng-container *ngIf="isVisible">
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_8445_64429)">
        <path
          d="M8.50352 4.5C5.59442 4.5 3.11006 6.30945 2.10352 8.86364C3.11006 11.4178 5.59442 13.2273 8.50352 13.2273C11.4126 13.2273 13.897 11.4178 14.9035 8.86364C13.897 6.30945 11.4155 4.5 8.50352 4.5ZM8.50352 11.7727C6.8977 11.7727 5.59442 10.4695 5.59442 8.86364C5.59442 7.25782 6.8977 5.95455 8.50352 5.95455C10.1093 5.95455 11.4126 7.25782 11.4126 8.86364C11.4126 10.4695 10.1093 11.7727 8.50352 11.7727ZM8.50352 7.11818C7.54061 7.11818 6.75806 7.90073 6.75806 8.86364C6.75806 9.82655 7.54061 10.6091 8.50352 10.6091C9.46642 10.6091 10.249 9.82655 10.249 8.86364C10.249 7.90073 9.46642 7.11818 8.50352 7.11818Z"
          fill="black"
          fill-opacity="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_8445_64429">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </ng-container>
  <ng-container *ngIf="!isVisible">
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.40625 6.39935L10.2382 8.23173L10.247 8.13575C10.247 7.17301 9.46474 6.39062 8.50221 6.39062L8.40625 6.39935Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M8.50508 5.22575C10.1103 5.22575 11.413 6.52878 11.413 8.13429C11.413 8.5095 11.3374 8.86725 11.2066 9.1959L12.9077 10.8974C13.7859 10.1644 14.478 9.21627 14.9054 8.13429C13.8964 5.58061 11.4159 3.77148 8.50511 3.77148C7.69088 3.77148 6.91157 3.9169 6.1875 4.17867L7.44372 5.43224C7.77228 5.30428 8.12996 5.22575 8.50508 5.22575Z"
        fill="black"
        fill-opacity="0.2"
      />
      <path
        d="M3.0577 3.27133C2.85298 3.4761 2.85298 3.80804 3.0577 4.0128L4.01306 4.96836L4.27769 5.23305C3.31807 5.98345 2.55911 6.98109 2.10547 8.13576C3.11162 10.6895 5.59498 12.4986 8.50291 12.4986C9.40438 12.4986 10.2651 12.3241 11.0532 12.007L11.3004 12.2543L12.6264 13.5829C12.8304 13.7873 13.1614 13.7877 13.366 13.5839V13.5839C13.5709 13.3798 13.5713 13.048 13.3668 12.8434L3.79938 3.27139C3.59461 3.06651 3.2625 3.06649 3.0577 3.27133V3.27133ZM5.90323 6.85601L6.80178 7.75475C6.77561 7.87983 6.75816 8.00488 6.75816 8.13576C6.75816 9.0985 7.54038 9.88089 8.50291 9.88089C8.63377 9.88089 8.75882 9.86344 8.88095 9.83726L9.7795 10.736C9.39274 10.928 8.96238 11.0443 8.50291 11.0443C6.89774 11.0443 5.59498 9.74128 5.59498 8.13576C5.59498 7.67622 5.71131 7.24575 5.90323 6.85601Z"
        fill="black"
        fill-opacity="0.2"
      />
    </svg>
  </ng-container>
</div>
